<template>
    <div class="records-table">
        <div class="table-toolbar">
          <div class="left">
            <FormulateInput type="search" v-model="query" @input="tableSearch"></FormulateInput>
            </div>
            <div class="right text-right">
              <button class="btn" @click="download"><i class="fa fa-download"></i></button>
            </div>
        </div>
        <transition name="fade">
          <div id="wrapper" class='wrapper small'>
                <div class="table-responsive">
                  <table class="table table-bordered table-hover table-striped contacts-queue-table">
                    <thead>
                      <tr>
                        <th></th>
                        <th v-for="(item, $index) in tableData.header">
                          {{ item.label }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="tableData.count == 0">
                        <td :colspan="tableData.header.length + 1" class="text-center"><i>No results</i></td>
                      </tr>
                      <tr v-else v-for="(row, $rowIndex) in tableData.results" :key="row.id">
                        <td><a class="btn" role="button" @click="showRecord(row.id)"><i class="fa fa-info"></i></a></td>
                        <table-cell v-for="(column, $columnIndex) in tableData.header" :value="row[column.name]" :valueType="column.type" :childValueType="column.child_type" :key="$rowIndex + '-' + $columnIndex">
                        </table-cell>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="ls-table-pagination">
                  <button type="button" class="btn btn-primary" :disabled="!tableData.previous" @click="prevPage"><i class="fa fa-arrow-left"></i> prev</button> |
                  <button type="button" class="btn btn-primary" :disabled="!tableData.next" @click="nextPage">next <i class="fa fa-arrow-right"></i></button>
                  <span>Records: <b>{{ tableData.count }}</b></span>
                </div>
            </div>
        </transition>
        <!-- END ENDLESS TABLE -->

        <!-- END LEAD DETAIL -->
    </div>
</template>

<script>

 // http://mkoryak.github.io/floatThead/#examples

  import Vue from 'vue';
  import TableCell from 'components/elements/TableCell';

  export default {
    name: 'records-table',
    props: {
      searchContext: {
        required: false,
        default: {
          page: 1,
          search: null
        }
      },
      tableData: {
        default: {
          count: 0,
          next: null,
          previous: null,
          header: [],
          results: []
        }
      }
    },
    components: {
      TableCell
    },
    data () {
      return {
        query: null,
        checked: [],
      };
    },
    computed: {
      columnKeys() {
        return this.tableData.header.map((item) => item.name);
      }
    },
    watch: {
      searchContext: {
        handler: function (newValue, oldValue) {
          if (newValue.search == null) {
            this.query = null;
          }
        },
        deep: true,
      }
    },
    created () {
    },
    methods: {
      tableSearch(searchTerm) {
        this.$emit('search', {search: searchTerm});
      },
      nextPage() {
        this.$emit('search', {page: this.searchContext.page + 1});
      },
      prevPage() {
        this.$emit('search', {page: this.searchContext.page - 1});
      },
      enable() {
        this.toggle('active');
      },
      disable() {
        this.toggle('disabled');
      },
      showRecord(agentId) {
        this.$emit('showRecord', agentId);
      },
      download () {
        this.$emit('download');
      }
    }
  };
</script>

<style lang="scss">
  .records-table {

    border-radius: 4px;
    padding: 10px;

    th, .th {
      background: #f38c3d;
      color: #fff;
    }

    td {
      white-space: nowrap;
    }

    td>.btn {
      text-align: center;
      padding: 0px 6px;
    }

    .wrapper {
      position: relative;
    }

    .wrapper.small {
      height: 100%;
      width: 100%;
    }
    .not-visible {
      visibility: hidden;
    }

    tr.not-visible,
    tr.not-visible td {
      padding: 0 !important;
      height: 0 !important;
      line-height: 0 !important;
    }

    tr.not-visible td div {
      display: inline-block;
      white-space: nowrap;
      margin-right: 42px;
      font-weight: 500;
      font-size: 16px;
      line-height: 0;
    }
  }

 .table-toolbar {
   .formulate-input {
     margin-bottom: 2px;

     input {
       background-color: #fff;
     }

     select {
       background-color: #fff;
     }

     .formulate-input-element-decorator {
       background-color: #fff;
     }
   }

   button + button,
   button + .formulate-input,
   .formulate-input + .formulate-input {
     margin-left: .5em;
   }
   .left {
     flex-grow: 1;
     display: flex;
     flex-direction: row;

     div.text-left {
       line-height: 2.5rem;
     }
   }
   .right {
     display: flex;
     flex-direction: row;
     flex-grow: 2;
     gap: .5rem;
     justify-content: flex-end;

     .formulate-input[data-classification="group"] .formulate-input-group-item {
       display: inline-block;
       margin-left: 10px;
       margin-top: 4px;

       .formulate-input-element--checkbox {
         margin-bottom: -6px;
       }

       .formulate-input-label--after {
         margin-bottom: 0px;
       }
     }
   }
 }
</style>



// WEBPACK FOOTER //
// RecordsTable.vue?630a8f47